export default {
  methods: {
    // Parse a boolean number/boolean/string into a true/false value
    parseBoolean(value) {
      if(value == null)
        return false
      if (typeof value === 'boolean')
        return (value === true)

      if(typeof value === 'string') {
        if(value == '')
          return false;

        value = value.replace(/^\s+|\s+$/g, '');
        if(value.toLowerCase() == 'true' || value.toLowerCase() == 'yes')
          return true
      }

      if(!isNaN(value))
        return (parseFloat(value) != 0)

      return false
    },

    parseDecimal(value) {
      if(value == null)
        return 0
        
      let result = parseFloat(value)
      if(isNaN(result))
        return 0

      return result
    }
  }
}